import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Popconfirm } from 'antd';
import { useB2cPmlDetail } from 'hooks';
import { RangePicker, Debirefing, Pm } from 'components/atoms'
import moment, { Moment } from 'moment';
import { dateFormat } from 'utils/date-utils';
import { RangeValue } from 'rc-picker/lib/interface';
import { getCodeNumberArray } from 'utils/form-utils';
import CheckDuplicateModal from 'components/molecules/CheckDuplicateModal';
import { IMaskInput } from "react-imask";

export interface B2cEditModalProps extends PopupProps {
    id: number;
}

const B2cPmlEditModal = ({ 
    isOpen, 
    onClose, 
    id}: B2cEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isCheckConfirm, setIsCheckConfirm] = useState<boolean>(false);   
    const [checkMessage, setCheckMessage] = useState<string>('');
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const [lectureOpt, setLectureOpt] = useState<LectureCodeListDto>();
    const [studyStartDate, setStudyStartDate] = useState<string>();
    const [studyEndDate, setStudyEndDate] = useState<string>();
    const [closeYn, setCloseYn] = useState<string>('N'); 
    const [margin, setMargin] = useState<string>('0 (0%)');
    const [max_price, setMax_price] = useState<number>(0);
    const [lecturer_in_price, setLecturer_in_price] = useState<number>(0);    
    const [place_price, setPlace_price] = useState<number>(0);
    const [print_price, setPrint_price] = useState<number>(0);
    const [etc_price, setEtc_price] = useState<number>(0);   

  /* ======================================================
  * hooks
  * ====================================================== */
  const onIsClose = (isOk) => {
    if (isOk) setCloseYn(closeYn==='Y'?'N':'Y')
 }

  const { b2cInfo, insertSuccess, updateSuccess, deleteSuccess, closeSuccess, dropSuccess, b2cInsert, b2cUpdate, b2cDelete, b2cClose, b2cDrop} = useB2cPmlDetail(id, onIsClose);

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const configBlocks = {
    PriceInput: {
      mask: Number,
      signed: true,  // disallow negative
      thousandsSeparator: ",",  // any single char
      padFractionalZeros: false,
      normalizeZeros: false,
      unmask: true // true|false|'typed'
    }
  }   
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        const debriefing_time = e.debriefing_time;
        let start_time: string | null = null;
        let end_time: string | null = null
        let debriefing_date: string | null = null;

        if (e.debriefing_date) {
            debriefing_date = dateFormat(e.debriefing_date, 'YYYY-MM-DD');
            if (debriefing_time) {
                start_time = debriefing_date + ' ' +moment(debriefing_time[0]).format('HH:mm'); 
                end_time = debriefing_date + ' ' +moment(debriefing_time[1]).format('HH:mm');
            }                
        }

        if (id > 0) {
            b2cUpdate({
                id: id,
                start_date: startDate,
                end_date: endDate,
                study_start_date: studyStartDate,
                study_end_date: studyEndDate,
                debriefing_date: debriefing_date,
                debriefing_start_time: start_time,
                debriefing_end_time: end_time,
                lecturer_srl: e.lecturer_srl,
                memo: e.memo,
                pm: e.pm,
                title: e.title,
                lecturer_in_price: lecturer_in_price,
                place_price: place_price,
                print_price: print_price,
                etc_price: etc_price,   
                expect_price: Number(form.getFieldValue('expect_price').toString().replaceAll(',','')) | 0,                
            })  
        } else {
            b2cInsert({
                id: id,
                start_date: startDate,
                end_date: endDate,
                study_start_date: studyStartDate,
                study_end_date: studyEndDate,
                debriefing_date: debriefing_date,
                debriefing_start_time: start_time,
                debriefing_end_time: end_time,
                lecturer_srl: e.lecturer_srl,
                memo: e.memo,
                pm: e.pm,
                title: e.title,
                lecturer_in_price: lecturer_in_price,
                place_price: place_price,
                print_price: print_price,
                etc_price: etc_price,   
                expect_price: Number(form.getFieldValue('expect_price').toString().replaceAll(',','')) | 0,                     
            }) 
        }
    };

    const calcMargin = () => {
        if (max_price > 0) {
            const calc = max_price - lecturer_in_price - place_price - print_price - etc_price;
            const str = calc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            const per  = ((calc / max_price)*100).toFixed(0);
            setMargin(str+'('+per+'%)');
        }
    }

    const onChangeForm = () => { 
        setIsFormDone(true);   
    };      

      const onDiagnoseDateChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
   
        const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYY-MM-DD') : undefined;
        const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYY-MM-DD') : undefined;
    
        setStartDate(searchDateS);
        setEndDate(searchDateE);
        onChangeForm();
      };
    
      const onStudyDateChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
       
        const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYY-MM-DD') : undefined;
        const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYY-MM-DD') : undefined;
    
        setStudyStartDate(searchDateS);
        setStudyEndDate(searchDateE);
        onChangeForm();
      };  

    const onSelectLectur = (opt: LectureCodeListDto) => {
        setLectureOpt(opt)
    }      

  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!b2cInfo) {            
            if (!!b2cInfo.start_date && b2cInfo.start_date !== '0000-00-00' && !!b2cInfo.end_date && b2cInfo.end_date !== '0000-00-00') {
                setStartDate(b2cInfo.start_date);
                setEndDate(b2cInfo.end_date);
            }   

            if (!!b2cInfo.study_start_date && b2cInfo.study_start_date !== '0000-00-00' && !!b2cInfo.study_end_date && b2cInfo.study_end_date !== '0000-00-00') {
                setStudyStartDate(b2cInfo.study_start_date);
                setStudyEndDate(b2cInfo.study_end_date);
            }  

            form.setFieldsValue({
                lecture_gid: b2cInfo.lecture_gid || undefined, 
                title: b2cInfo.title,
                diagnose_date: (!!b2cInfo.start_date && b2cInfo.start_date !== '0000-00-00' && !!b2cInfo.end_date && b2cInfo.end_date !== '0000-00-00')?[moment(b2cInfo.start_date, "YYYY-MM-DD"), moment(b2cInfo.end_date, "YYYY-MM-DD")]:[], 
                debriefing_date: (!!b2cInfo.debriefing_date && b2cInfo.debriefing_date !== '0000-00-00') ? moment(b2cInfo.debriefing_date, "YYYY-MM-DD") : undefined,
                debriefing_time: b2cInfo.debriefing_start_time ? [moment(b2cInfo.debriefing_start_time, 'HH:mm'), moment(b2cInfo.debriefing_end_time, 'HH:mm')]: [] ,
                study_date: (!!b2cInfo.study_start_date && b2cInfo.study_start_date !== '0000-00-00' && !!b2cInfo.study_end_date && b2cInfo.study_end_date !== '0000-00-00')?[moment(b2cInfo.study_start_date, "YYYY-MM-DD"), moment(b2cInfo.study_end_date, "YYYY-MM-DD")]:[], 
                lecturer_srl: b2cInfo?.lecturer_srl>0?b2cInfo.lecturer_srl:null,
                memo: b2cInfo.memo,
                pm: getCodeNumberArray(b2cInfo.pm),
                lecturer_in_price: b2cInfo.lecturer_in_price || 0,
                place_price: b2cInfo.place_price || 0,
                print_price: b2cInfo.print_price || 0,
                etc_price: b2cInfo.etc_price || 0,                
                expect_price: b2cInfo.expect_price || 0,                
            });

            setMax_price(b2cInfo.max_price || 0);
            setLecturer_in_price(b2cInfo.lecturer_in_price || 0);
            setPlace_price(b2cInfo.place_price || 0);
            setPrint_price(b2cInfo.print_price || 0);
            setEtc_price(b2cInfo.etc_price || 0);
            setCloseYn(b2cInfo.close_yn  || 'N');

            calcMargin();

        }
    }, [b2cInfo])

    useEffect(() => {
        form.setFieldsValue({
            lecturer_in_price: 0,
            place_price: 0,
            print_price: 0,
            etc_price: 0,                
            expect_price: 0,
        });
    }, [])

    useEffect(() => {
        calcMargin();
    }, [max_price,lecturer_in_price,place_price,print_price,etc_price])    

    useEffect(() => {
        if (insertSuccess || updateSuccess || deleteSuccess || dropSuccess) {
            onClose?.(true);  
        }
    }, [insertSuccess, updateSuccess, deleteSuccess, dropSuccess])

    return (
    <>
         <ModalWrapper open={isOpen} onCancel={onCancel} width={750} title={id===0?'성과백신 진단 일정 등록':'성과백신 진단 일정 수정'} closable>
            <Form
                form={form}
                name="ProjectInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item  name="title" label={'과정명'}>
                  <Input type='text' />                  
                </Form.Item>   
                <Form.Item name="diagnose_date" label={'진단 기간'} rules={[{ type: 'array' as const, required: false, message: '' }]}>
                    <RangePicker format="YYYY-MM-DD" onChange={onDiagnoseDateChangePeriod} style={{width:'250px'}} />                                   
                </Form.Item>  
                <Form.Item label={'디브리핑'} >
                    <Debirefing form={form} />                                   
                </Form.Item>                  
                <Form.Item name="study_date" label={'영상학습 기간'} rules={[{ type: 'array' as const, required: false, message: '' }]}>
                    <RangePicker format="YYYY-MM-DD" onChange={onStudyDateChangePeriod} style={{width:'250px'}} />                                   
                </Form.Item>  
                <Form.Item label={'PM'}>
                    <Pm fieldname={'pm'} />   
                </Form.Item>    
                <Form.Item name="expect_price" label={'예상매출'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('expect_price', value);})}/>
                </Form.Item>                   
                <Form.Item label={'매출'}>
                    <label>{b2cInfo?.max_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}&nbsp;&nbsp;&nbsp;매출이익 : {margin}</label> 
                </Form.Item> 
                <Form.Item name='lecturer_in_price' label={'내부강사료'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('lecturer_in_price', value);setLecturer_in_price(Number(value));})}/>
                </Form.Item>
                <Form.Item name='place_price' label={'교육장(식사,다과포함)'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('place_price', value);setPlace_price(Number(value));})}/>
                </Form.Item>   
                <Form.Item name='print_price' label={'인쇄비'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('print_price', value);setPrint_price(Number(value));})}/>
                </Form.Item>   
                <Form.Item name='etc_price' label={'기타비용'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('etc_price', value);setEtc_price(Number(value));})}/>
                </Form.Item>                       
                <Form.Item name='memo' label={'메모'}>
                    <TextArea rows={3} placeholder='일정 메모를 입력하세요'/>   
                </Form.Item>  
                {(id>0) && (
                <Form.Item label={'모집중/마감'}>
                    <Popconfirm
                        title={closeYn==='Y'?'모집중 상태로 변경 하시겠습니까?':'마감 상태로 변경 하시겠습니까?'} 
                        okText={closeYn==='Y'?'모집중':'마감'} 
                        cancelText="취소"
                        onConfirm={() => { b2cClose({id:id, close_yn:closeYn==='Y'?'N':'Y'})}}
                    >   
                        <Button>{closeYn==='Y'?'마감':'모집중'}</Button>
                    </Popconfirm>
                </Form.Item>                                 
                )}                   
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <div>
                        {(id>0) && (
                            <>
                            <Popconfirm
                                title="삭제 하시겠습니까?"
                                okText="삭제"
                                cancelText="취소"
                                onConfirm={() => { b2cDelete({id:id})}}
                            >   
                                <Button danger style={{marginRight: "5px"}}>삭제</Button>        
                            </Popconfirm>
                            <Popconfirm
                                title="폐강 하시겠습니까? 폐강 처리시 스케줄은 삭제됩니다."
                                okText="폐강"
                                cancelText="취소"
                                onConfirm={() => { b2cDrop({id:id})}}
                            >   
                                <Button danger style={{marginRight: "5px"}}>폐강</Button>        
                            </Popconfirm>                            
                            </>
                        )}
                        <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{id===0?'등록':'수정'}</Button>
                    </div>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
        <CheckDuplicateModal
            title="스케줄 확인"
            message={checkMessage}
            visible={isCheckConfirm}
            onOk={() => setIsCheckConfirm(false)}
        />           
        </>
    )    
};

export default React.memo(B2cPmlEditModal);    